import React from 'react';
import './styles.scss';
import { TEI_TYPES } from 'legacy-src/constants/assignment';

const ResponseDistribution = ({
  responseDistribution,
  rightAnswer,
  questionType = '',
}) => {
  const isTei = TEI_TYPES.includes(questionType);

  if (isTei) {
    return (
      <div className="w-80 flex justify-center font-normal text-base text-gray-600 text-center px-4">
        Unavailable for <br /> technology-enhanced questions
      </div>
    );
  }

  if (!rightAnswer || !responseDistribution) {
    return null;
  }

  const totalResponses = Math.max(...Object.values(responseDistribution));

  const calculateBackgroundColor = (key) => {
    if (key === '—') {
      return '#D4D4D8';
    }
    if (key === rightAnswer) {
      return '#3F7B33';
    }
    return '#C13145';
  };

  return (
    <div className="distribution-container">
      <div className="wrapper-bars">
        {Object.keys(responseDistribution).map((key) => (
          <div className="wrapper-bar" key={Math.random()}>
            <div
              className="bar"
              style={{
                height: `${
                  (responseDistribution[key] * 100) / totalResponses
                }%`,
                backgroundColor: calculateBackgroundColor(key),
              }}
            >
              &nbsp;
            </div>
          </div>
        ))}
      </div>
      <div className="wrappers-labels">
        {Object.keys(responseDistribution).map((key) => (
          <div className="label" key={Math.random()}>
            {key}
          </div>
        ))}
      </div>
    </div>
  );
};

ResponseDistribution.defaultProps = {
  responseDistribution: {},
  rightAnswer: '',
};

export default ResponseDistribution;
